export const name = 'message';

export const Message = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4057 14.9709L8.91993 13.6539L6.85788 11.826L5.86287 12.9485L7.92491 14.7764L10.5025 17.0613L11.0163 16.4816L18.1601 9.33779L17.0994 8.27713L10.4057 14.9709Z"
      fill="currentColor"
    />
    <path
      d="M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);
